import { Bell, Search, Menu } from 'lucide-react'
import { ThemeToggle } from '@/components/ui/ThemeToggle'

interface HeaderProps {
  onMenuClick?: () => void
}

export default function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className="flex h-16 flex-shrink-0 items-center gap-3 border-b border-border bg-background px-4 md:px-6">
      {/* Mobile menu button */}
      <button
        onClick={onMenuClick}
        className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-accent md:hidden"
        aria-label="Open navigation menu"
      >
        <Menu className="h-4 w-4" />
      </button>

      {/* Search — hidden on mobile, visible from md */}
      <label className="hidden md:flex flex-1 items-center gap-2 rounded-md border border-input bg-secondary/50 px-3 py-2 text-sm text-muted-foreground cursor-text hover:bg-secondary transition-colors max-w-sm">
        <Search className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <span>Search...</span>
        <input className="sr-only" aria-label="Search" readOnly />
      </label>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Actions */}
      <div className="flex items-center gap-1">
        {/* Mobile search icon */}
        <button
          className="flex h-10 w-10 items-center justify-center rounded-md hover:bg-accent transition-colors md:hidden"
          aria-label="Search"
        >
          <Search className="h-4 w-4" />
        </button>

        <button
          className="flex h-10 w-10 items-center justify-center rounded-md hover:bg-accent transition-colors relative"
          aria-label="Notifications"
        >
          <Bell className="h-4 w-4" />
          <span className="absolute top-2 right-2 h-2 w-2 rounded-full bg-primary" aria-hidden="true" />
        </button>

        <ThemeToggle />

        {/* Avatar */}
        <button
          className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground hover:opacity-90 transition-opacity ml-1"
          aria-label="User menu"
        >
          A
        </button>
      </div>
    </header>
  )
}
